/* eslint-disable */
export default [
  //AUSTRALIA
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'New South Wales',
    'alpha2': 'NS',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'Victoria',
    'alpha2': 'VI',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'Queensland',
    'alpha2': 'QL',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'Western Australia',
    'alpha2': 'WA',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'South Australia',
    'alpha2': 'SA',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'Tasmania',
    'alpha2': 'TS',
  },
  {
    'country_id': '14',
    'country_name': 'Australia',
    'country_alpha2': 'AU',
    'name': 'Northern Territory',
    'alpha2': 'NT',
  },
  // SWITZERLAND
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Aargau',
    'alpha2': 'AG',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Appenzell Innerrhoden',
    'alpha2': 'AI',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Appenzell Ausserrhoden',
    'alpha2': 'AR',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Berne',
    'alpha2': 'BE',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Basel-Landschaft',
    'alpha2': 'BL',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Basel-Stadt',
    'alpha2': 'BS',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Fribourg',
    'alpha2': 'FR',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Geneva',
    'alpha2': 'GE',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Glarus',
    'alpha2': 'GL',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Grisons',
    'alpha2': 'GR',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Jura',
    'alpha2': 'JU',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Lucerne',
    'alpha2': 'LU',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Neuchâtel',
    'alpha2': 'NE',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Nidwalden',
    'alpha2': 'NW',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Obwalden',
    'alpha2': 'OW',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'St. Gallen',
    'alpha2': 'SG',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Schaffhausen',
    'alpha2': 'SH',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Solothurn',
    'alpha2': 'SO',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Schwyz',
    'alpha2': 'SZ',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Thurgau',
    'alpha2': 'TG',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Ticino',
    'alpha2': 'TI',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Uri',
    'alpha2': 'UR',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Vaud',
    'alpha2': 'VD',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Valais',
    'alpha2': 'VS',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Zug',
    'alpha2': 'ZG',
  },
  {
    'country_id': '216',
    'country_name': 'Switzerland',
    'country_alpha2': 'CH',
    'name': 'Zürich',
    'alpha2': 'ZH',
  },
  // GERMANY ========================================================================
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Baden-Württemberg',
    'alpha2': 'BW',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Bavaria',
    'alpha2': 'BY',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Berlin',
    'alpha2': 'BE',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Brandenburg',
    'alpha2': 'BB',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Bremen',
    'alpha2': 'HB',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Hamburg',
    'alpha2': 'HH',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Hesse',
    'alpha2': 'HE',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Lower Saxony',
    'alpha2': 'NI',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Mecklenburg-Vorpommern',
    'alpha2': 'MV',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'North Rhine-Westphalia',
    'alpha2': 'NW',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Rhineland-Palatinate',
    'alpha2': 'RP',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Saarland',
    'alpha2': 'SL',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Saxony',
    'alpha2': 'SN',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Saxony-Anhalt',
    'alpha2': 'ST',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Schleswig-Holstein',
    'alpha2': 'SH',
  },
  {
    'country_id': '83',
    'country_name': 'Germany',
    'country_alpha2': 'DE',
    'name': 'Thuringia',
    'alpha2': 'TH',
  },
  // USA ========================================================================
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Alabama',
    'alpha2': 'AL',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Alaska',
    'alpha2': 'AK',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Arizona',
    'alpha2': 'AZ',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Arkansas',
    'alpha2': 'AR',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'California',
    'alpha2': 'CA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Colorado',
    'alpha2': 'CO',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Connecticut',
    'alpha2': 'CT',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Delaware',
    'alpha2': 'DE',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'District of Columbia',
    'alpha2': 'DC',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Florida',
    'alpha2': 'FL',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Georgia',
    'alpha2': 'GA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Hawaii',
    'alpha2': 'HI',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Idaho',
    'alpha2': 'ID',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Illinois',
    'alpha2': 'IL',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Indiana',
    'alpha2': 'IN',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Iowa',
    'alpha2': 'IA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Kansas',
    'alpha2': 'KS',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Kentucky',
    'alpha2': 'KY',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Louisiana',
    'alpha2': 'LA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Mafine',
    'alpha2': 'ME',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Maryland',
    'alpha2': 'MD',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Massachusetts',
    'alpha2': 'MA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Michigan',
    'alpha2': 'MI',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Minnesota',
    'alpha2': 'MN',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Mississippi',
    'alpha2': 'MS',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Missouri',
    'alpha2': 'MO',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Montana',
    'alpha2': 'MT',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Nebraska',
    'alpha2': 'NE',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Nevada',
    'alpha2': 'NV',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'New Hampshire',
    'alpha2': 'NH',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'New Jersey',
    'alpha2': 'NJ',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'New Mexico',
    'alpha2': 'NM',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'New York',
    'alpha2': 'NY',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'North Carolina',
    'alpha2': 'NC',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'North Dakota',
    'alpha2': 'ND',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Ohio',
    'alpha2': 'OH',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Oklahoma',
    'alpha2': 'OK',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Oregon',
    'alpha2': 'OR',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Pennsylvania',
    'alpha2': 'PA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Rhode Island',
    'alpha2': 'RI',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'South Carolina',
    'alpha2': 'SC',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'South Dakota',
    'alpha2': 'SD',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Tennessee',
    'alpha2': 'TN',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Texas',
    'alpha2': 'TX',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Utah',
    'alpha2': 'UT',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Vermont',
    'alpha2': 'VT',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Virginia',
    'alpha2': 'VA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Washington',
    'alpha2': 'WA',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'West Virginia',
    'alpha2': 'WV',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Wisconsin',
    'alpha2': 'WI',
  },
  {
    'country_id': '236',
    'country_name': 'United States of America',
    'country_alpha2': 'US',
    'name': 'Wyoming',
    'alpha2': 'WY',
  },
  // IRELAND ========================================================================
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Carlow',
    'alpha2': 'CW',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Cavan',
    'alpha2': 'CV',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Clare',
    'alpha2': 'CL',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Cork',
    'alpha2': 'CK',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Donegal',
    'alpha2': 'DG',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Dublin',
    'alpha2': 'DB',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Galway ',
    'alpha2': 'GW',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Kerry',
    'alpha2': 'KY',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Kildare',
    'alpha2': 'KD',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Kilkenny',
    'alpha2': 'KK',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Laois',
    'alpha2': 'LS',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Leitrim',
    'alpha2': 'LM',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Limerick',
    'alpha2': 'LI',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Longford',
    'alpha2': 'LF',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Louth',
    'alpha2': 'LT',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Mayo',
    'alpha2': 'MY',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Meath',
    'alpha2': 'MT',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Monaghan',
    'alpha2': 'MH',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Offaly',
    'alpha2': 'OF',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Roscommon',
    'alpha2': 'RC',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Sligo',
    'alpha2': 'SG',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Tipperary',
    'alpha2': 'TP',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Waterford',
    'alpha2': 'WF',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Westmeath',
    'alpha2': 'WM',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Wexford',
    'alpha2': 'WF',
  },
  {
    'country_id': '107',
    'country_name': 'Ireland ',
    'country_alpha2': 'IE',
    'name': 'Wicklow',
    'alpha2': 'WK',
  },
  // CANADA ========================================================================
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Alberta',
    'alpha2': 'AB',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'British Columbia',
    'alpha2': 'BC',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Manitoba',
    'alpha2': 'MB',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'New Brunswick',
    'alpha2': 'NB',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Newfoundland',
    'alpha2': 'NL',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Northwest Territories',
    'alpha2': 'NT',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Nova Scotia',
    'alpha2': 'NS',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Nunavut',
    'alpha2': 'NU',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Ontario',
    'alpha2': 'ON',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Prince Edward Island',
    'alpha2': 'PE',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Quebec',
    'alpha2': 'QC',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Saskatchewan',
    'alpha2': 'SK',
  },
  {
    'country_id': '40',
    'country_name': 'Canada ',
    'country_alpha2': 'CA',
    'name': 'Yukon',
    'alpha2': 'YT',
  },
  // CHINA ========================================================================
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Anhui',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Beijing',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Chongqing',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Fujian',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Gansu',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Guangdong',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Guizhou',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Hainan',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Hebei',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Heilongjiang',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Henan',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Hubei',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Hunan',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Jiangsu',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Jiangxi',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Jilin',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Liaoning',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Nei Mongol',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Qinghai',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Shaanxi',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Shandong',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Shanghai',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Shanxi',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Sichuan',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Tianjin',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Xinjiang',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Yunnan',
    'alpha2': '',
  },
  {
    'country_id': '46',
    'country_name': 'China ',
    'country_alpha2': 'CN',
    'name': 'Zhejiang',
    'alpha2': '',
  },
  // INDIA ========================================================================
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Andaman & Nicobar (U.T)',
    'alpha2': 'AN',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Andhra Pradesh',
    'alpha2': 'AP',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Arunachal Pradesh',
    'alpha2': 'AR',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Assam',
    'alpha2': 'AS',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Bihar',
    'alpha2': 'BR',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Chattisgarh',
    'alpha2': 'CG',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Chandigarh (U.T.)',
    'alpha2': 'CH',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Daman & Diu (U.T.)',
    'alpha2': 'DD',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Delhi (U.T.)',
    'alpha2': 'Dl',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Dadra and Nagar Haveli (U.T.)',
    'alpha2': 'DN',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Goa',
    'alpha2': 'GA',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Gujarat',
    'alpha2': 'GJ',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Haryana',
    'alpha2': 'HR',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Himachal Pradesh',
    'alpha2': 'HP',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Jammu & Kashmir',
    'alpha2': 'JK',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Jharkhand',
    'alpha2': 'JH',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Karnataka',
    'alpha2': 'KA',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Kerala',
    'alpha2': 'KL',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Lakshadweep (U.T)',
    'alpha2': 'LD',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Madhya Pradesh',
    'alpha2': 'MP',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Maharashtra',
    'alpha2': 'MH',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Manipur',
    'alpha2': 'MN',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Meghalaya',
    'alpha2': 'ML',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Mizoram',
    'alpha2': 'MZ',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Nagaland',
    'alpha2': 'NL',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Orissa',
    'alpha2': 'OR',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Punjab',
    'alpha2': 'PB',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Puducherry (U.T.)',
    'alpha2': 'PY',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Rajasthan',
    'alpha2': 'RJ',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Sikkim',
    'alpha2': 'SK',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Tamil Nadu',
    'alpha2': 'TN',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Tripura',
    'alpha2': 'TR',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Uttaranchal',
    'alpha2': 'UA',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'Uttar Pradesh',
    'alpha2': 'UP',
  },
  {
    'country_id': '103',
    'country_name': 'India ',
    'country_alpha2': 'IN',
    'name': 'West Bengal',
    'alpha2': 'WB',
  },
  // MEXICO ========================================================================
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Aguascalientes',
    'alpha2': 'AG',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Baja California',
    'alpha2': 'BC',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Baja California Sur',
    'alpha2': 'BS',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Campeche',
    'alpha2': 'CM',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Chiapas',
    'alpha2': 'CS',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Chihuahua',
    'alpha2': 'CH',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Ciudad de México',
    'alpha2': 'DF',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Coahuila',
    'alpha2': 'CO',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Colima',
    'alpha2': 'CL',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Durango',
    'alpha2': 'DG',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Estado de México',
    'alpha2': 'EM',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Guanajuato',
    'alpha2': 'GT',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Guerrero',
    'alpha2': 'GR',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Hidalgo',
    'alpha2': 'HG',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Jalisco',
    'alpha2': 'JA',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Michoacán',
    'alpha2': 'MI',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Morelos',
    'alpha2': 'MO',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Nayarit',
    'alpha2': 'NA',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Nuevo León',
    'alpha2': 'NL',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Oaxaca',
    'alpha2': 'OA',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Puebla',
    'alpha2': 'PU',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Querétaro',
    'alpha2': 'QE',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Quintana Roo',
    'alpha2': 'QR',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'San Luis Potosí',
    'alpha2': 'SL',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Sinaloa',
    'alpha2': 'SI',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Sonora',
    'alpha2': 'SO',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Tabasco',
    'alpha2': 'TB',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Tamaulipas',
    'alpha2': 'TM',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Tlaxcala',
    'alpha2': 'TL',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Veracruz',
    'alpha2': 'VE',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Yucatán',
    'alpha2': 'YU',
  },
  {
    'country_id': '144',
    'country_name': 'Mexico',
    'country_alpha2': 'MX',
    'name': 'Zacatecas',
    'alpha2': 'ZA',
  },
  // United Arab Emirates (UAE) ========================================================================
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Abu Dhabi',
    'alpha2': 'AB',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Ajman',
    'alpha2': 'AJ',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Dubai',
    'alpha2': 'DU',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Fujairah',
    'alpha2': 'FU',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Ras al-Khaimah',
    'alpha2': 'RA',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Sharjah',
    'alpha2': 'SH',
  },
  {
    'country_id': '234',
    'country_name': 'United Arab Emirates',
    'country_alpha2': 'AE',
    'name': 'Umm al-Quwain',
    'alpha2': 'UM',
  },

  // Malta (MLT) ========================================================================
  {
    'country_id': '138',
    'country_name': 'Malta',
    'country_alpha2': 'MT',
    'name': 'Central',
    'alpha2': 'CE',
  },
  {
    'country_id': '138',
    'country_name': 'Malta',
    'country_alpha2': 'MT',
    'name': 'Gozo',
    'alpha2': 'GO',
  },
  {
    'country_id': '138',
    'country_name': 'Malta',
    'country_alpha2': 'MT',
    'name': 'Northern',
    'alpha2': 'NO',
  },
  {
    'country_id': '138',
    'country_name': 'Malta',
    'country_alpha2': 'MT',
    'name': 'South Eastern',
    'alpha2': 'SE',
  },
  {
    'country_id': '138',
    'country_name': 'Malta',
    'country_alpha2': 'MT',
    'name': 'Southern',
    'alpha2': 'SO',
  },
]
